/**
 * GraphQL operations that are allowed to run without authentication
 * and should be considered for cache persistence
 */
export const ALLOWED_OPERATIONS = [
  'processingPartners',
  'processingPartnersOne',
  'processorSchedulingMany',
  'processorSchedulingOne',
  'ProcessorSchedulingById',
  'ViewProcessingPartner',
  'CreateProcessorScheduling',
  'ViewSchedulingCreate',
  'CutsheetCreateOne',
  'WaitlistAdd',
  'WaitlistUnsubscribe',
  'MyChatRooms',
  'MessagesByChatRoom',
  'SendMessage',
] as const;

/**
 * Operations that should be persisted to localStorage
 * This is a subset of ALLOWED_OPERATIONS focusing on cacheable queries
 * (excluding mutations and real-time data like chat messages)
 */
export const PERSISTENT_OPERATIONS = [
  'cancellationReasonMany',
  'UserTenantVendor',
  'userTenantVendor',
  'UserSettingsByUserId',
] as const;
